import { vuex as modules } from '../app'

export default { ...modules }



// WEBPACK FOOTER //
// ./src/store/modules.js